/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

export function AccordionUpdatedInitialTerms({ data }: { data: any[] }) {
  return (
    <AccordionItem value="initials" className="border border-gray-200 rounded-lg shadow-sm bg-white">
      <AccordionTrigger className="px-4 py-3 hover:bg-gray-50 rounded-t-lg font-semibold text-gray-900">
        Atualizações de Vigência Inicial
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        {data.map((item, i) => (
          <div
            key={i}
            className="border border-gray-200 p-4 rounded-lg bg-gradient-to-br from-gray-50 to-gray-100/50 mb-3 last:mb-0 grid grid-cols-2 gap-4 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Estado</Label>
              <Input
                value={item.state}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Novo Inicial</Label>
              <Input
                value={format(new Date(item.newInitialTerm), "dd/MM/yyyy", {
                  locale: ptBR,
                })}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
          </div>
        ))}
      </AccordionContent>
    </AccordionItem>
  );
}
